import React from 'react';
import CardTable from '../CardTable';
import { formatDate } from '../format';
import styles from '../card.module.css';

/* Вкладка «Материально-технические средства» (п. 9 ТЗ).
   Отказ сервера по правам обрабатывает карточка — вкладка скрывается целиком. */

const COLUMNS = [
  {
    key: 'invent',
    title: <>Инв.<br />номер</>,
    cell: row => row.invent_number,
    className: styles.mono,
  },
  { key: 'name', title: 'Название', cell: row => row.name, className: styles.lead },
  { key: 'group', title: 'Группа оборудования', cell: row => row.equip_group },
  { key: 'status', title: 'Состояние', cell: row => row.status },
  { key: 'unit', title: 'Ед. изм.', cell: row => row.unit },
  { key: 'type', title: 'Тип', cell: row => row.equip_type },
  { key: 'quantity', title: 'Количество', cell: row => row.quantity, className: styles.mono },
  { key: 'room', title: <>Аудитория<br />(подразделение)</>, cell: row => row.room },
  { key: 'responsible', title: 'Ответственный', cell: row => row.responsible },
  {
    key: 'income',
    title: <>Дата<br />оприходования</>,
    cell: row => formatDate(row.income_date),
    className: styles.mono,
  },
  {
    key: 'outcome',
    title: <>Дата<br />выбытия</>,
    cell: row => formatDate(row.outcome_date),
    className: styles.mono,
  },
  { key: 'description', title: 'Примечание', cell: row => row.description },
];

const Equipment = ({ data }) => (
  <CardTable
    columns={COLUMNS}
    rows={data.items}
    rowKey={row => row.idequipment}
    counter={<>Всего записей: <b>{data.count}</b></>}
    emptyTitle="Материально-технические средства не закреплены"
    emptyText="За факультетом не числится оборудования"
  />
);

export default Equipment;
